import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCreative, Navigation, Autoplay } from 'swiper';
import connected from '../../Assets/mobileApp/carouselScreens/AConnectedExperience-c.webp';
import experience from '../../Assets/mobileApp/carouselScreens/AnIntuitiveExperience-c.webp';
import digitalPayments from '../../Assets/mobileApp/carouselScreens/DigitizedPayments-c.webp';
import easySearch from '../../Assets/mobileApp/carouselScreens/EasySearch-c.webp';
import liveCharging from '../../Assets/mobileApp/carouselScreens/LiveCharging-c.webp';
import { gsap } from 'gsap';
import 'swiper/css/bundle';
import './styles/index.css';
import { SwitchTransition, Transition } from 'react-transition-group';

export default function ProductCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  const data = [
    {
      title: 'An Intuitive Experience',
      desc: 'Your partner in EV Charging, the VerdeMobility Mobile App is easy-to-use and provides one-stop access to all your EV Charging needs.',
      img: experience,
    },
    {
      title: 'Easy Search',
      desc: 'Through smart search, predefine your charging criteria to locate the most relevant EV Charging Stations near you. No surprises guaranteed!',
      img: easySearch,
    },
    {
      title: 'Live Charging Updates',
      desc: 'Run errands or enjoy lunch while your EV Charges! The VerdeMobility EV Charging Mobile App gives you feeds on the live charging status on-the-go!',
      img: liveCharging,
    },
    {
      title: 'Digitized Payments',
      desc: 'Through integrated billing and payments, enjoy an online payment experience with end-to-end encrypted safety.',
      img: digitalPayments,
    },
    {
      title: 'A Connected Experience',
      desc: 'The VerdeMobility EV Charging Network boasts OCPP compliance making you a part of its PAN India EV Charging Network. Charge wherever you go, whenever you go!',
      img: connected,
    },
  ];

  const exitAnim = (node) => {
    gsap.to(node, {
      duration: 0.3,
      opacity: 0,
    });
  };

  const enter = (node) => {
    gsap.fromTo(
      node,
      {
        opacity: 0,
      },
      {
        duration: 0.3,
        opacity: 1,
      }
    );
  };
  return (
    <>
      <div className="flex items-start justify-center  overflow-hidden  xLg:flex-row flex-col gap-x-10  xLg:w-11/12 mx-auto  blade-padding-top-sm">
        <div className="grow shrink basis-24 xl:min-h-[500px] flex flex-col justify-start  px-4  md:pl-6 lg:pl-10 h-[40rem] blade-padding-top-sm">
          <SwitchTransition>
            <Transition
              appear={true}
              timeout={300}
              in={true}
              key={activeIndex}
              onExit={exitAnim}
              onEnter={enter}
              mountOnEnter
              unmountOnExit
            >
              <div className=" max-w-2xl pt-10  xLg:max-w-lg  md:ml-auto grid">
                <h5 className="font-gilroy text-green font-semibold ">
                  {activeIndex + 1 + '/5'}
                </h5>
                <h3 className="font-gilroybold text-black leading-tight font-semibold xLg:max-w-lg mb-5 xLg:mb-10">
                  {data[activeIndex].title}
                </h3>
                <span className="font-poppins card-title-sm">
                  {data[activeIndex].desc}
                </span>
              </div>
            </Transition>
          </SwitchTransition>
        </div>
        <div className="grow overflow-hidden pt-10 xLg:pt-24 md:pb-20 shrink xLg:basis-[25rem] 2xl:basis-[30rem] relative">
          <div className="mask absolute top-0 left-0 bottom-0 right-0 z-10 pointer-events-none select-none sm:block hidden"></div>

          <div className="w-screen md:w-10/12 mx-auto relative overflow-hidden">
            <div className="md:max-w-screen-lg max-w-md mx-auto overflow-hidden">
              <Swiper
                autoHeight={true}
                slidesPerGroup={1}
                grabCursor={true}
                loop={true}
                centeredSlides={true}
                effect={'creative'}
                preloadImages={true}
                slidesPerView={1}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  650: {
                    centeredSlides: false,
                    slidesPerView: 1.3,
                    spaceBetween: 40,
                  },
                  768: {
                    centeredSlides: true,
                    slidesPerView: 2.5,
                  },
                  976: {
                    slidesPerView: 2.3,
                  },
                  1280: {
                    slidesPerView: 2,
                  },
                  1440: {
                    slidesPerView: 2,
                  },
                  1536: {
                    slidesPerView: 2,
                  },
                }}
                onSlideChange={(swiper) => {
                  return setActiveIndex(
                    (swiper.activeIndex - 2) % 5 >= 0
                      ? (swiper.activeIndex - 2) % 5
                      : 4
                  );
                }}
                creativeEffect={{
                  limitProgress: 3,
                  prev: {
                    shadow: false,
                    translate: [0, 0, -300],
                    opacity: 0,
                  },
                  next: {
                    translate: ['100%', 0, 0],
                  },
                }}
                modules={[EffectCreative, Navigation, Autoplay]}
                navigation={{
                  nextEl: '#swiper-forward',
                  prevEl: '#swiper-back',
                }}
                className="h-full"
              >
                {data.map((elem, index) => {
                  return (
                    <SwiperSlide
                      key={index}
                      className="md:pr-4 w-full md:pb-0 pb-2"
                    >
                      <div className="2xl:h-[600px] lg:h-[500px] h-[400px]">
                        <img
                          loading="lazy"
                          src={elem.img}
                          alt="slider"
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
            <div className="md:absolute static pt-2 top-auto left-auto right-8 md:mr-3 mb-5 xLg:right-4 bottom-3 flex md:flex-col flex-row-reverse justify-center gap-5 z-10">
              <button
                id="swiper-forward"
                className="stroke-green bg-white shadow-md  rounded-full grid h-12 place-content-center w-12 xLg:h-auto xLg:w-auto xLg:p-3 transition-colors duration-200 hover:bg-green hover:stroke-white  "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10"
                  fill="inherit"
                  viewBox="0 0 24 24"
                  stroke="inherit"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
              <button
                id="swiper-back"
                className="stroke-green bg-white shadow-md rounded-full grid xLg:h-auto xLg:w-auto h-12 w-12 place-content-center p-3 transition-colors duration-200 hover:bg-green hover:stroke-white "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10"
                  fill="inherit"
                  viewBox="0 0 24 24"
                  stroke="inherit"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M11 17l-5-5m0 0l5-5m-5 5h12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
